import { useTranslation } from '@dreamstack/i18n'
import { useMemo } from 'react'
import * as yup from 'yup'
import { useYupValidationResolver } from '../hooks/useYupValidationResolver'

export type Is24ContactFormData = {
  clientEmail: string
  clientFirstName: string
  clientLastName: string
  clientPhone: string
  clientSalutation: string
  text: string
  consent: boolean
  requestPhone: boolean
  clientCompanyName: string
}

export const useIs24ContactFormYupObject = () => {
  const t = useTranslation()
  const schema = useMemo(
    () => ({
      type: yup.string().default('is24contactform'),
      clientEmail: yup
        .string()
        .email(t('accentro:pleaseEnterAValidEmail'))
        .required(t('accentro:pleaseEnterAValidEmail')),
      clientFirstName: yup.string().required(t('accentro:requiredField')),
      clientLastName: yup.string().required(t('accentro:requiredField')),
      requestPhone: yup.boolean(),
      clientPhone: yup.string().when('requestPhone', {
        is: true,
        then: yup.string().required(t('accentro:requiredField')),
      }),
      text: yup.string().required(t('accentro:requiredField')),
      clientCompanyName: yup.string(),
      consent: yup
        .boolean()
        .oneOf([true], t('accentro:generalForm.requiredConsentMessage')),
    }),
    [t]
  )
  return schema
}

export const useIs24ContactFormSchema = () => {
  const schema = useIs24ContactFormYupObject()
  return useYupValidationResolver(yup.object(schema))
}
